<template>
  <v-container class="pa-0">
    <v-toolbar flat>
      <v-toolbar-title>Subscriptions</v-toolbar-title>

      <v-spacer/>

      <v-btn
        color="primary"
        rounded
        outlined
        @click="goToCreateSubscription()"
      >
        <v-icon left>
          add
        </v-icon>

        Create subscription
      </v-btn>
    </v-toolbar>
    <v-divider/>
    <base-stripe-table
      ref="subscriptionTable"
      :headers="headers"
      :fetch-action="'listSubscriptions'"
      :fetch-query="{ customer: id, expand: ['data.plan.product'], status: 'all' }"
      :items-getter="'getSubscriptions'"
      :pagination-getter="'getSubscriptionPagination'"
    >
      <template v-slot:body="{ items }">
        <tbody>
          <tr
            v-for="item in items"
            :key="item.id"
          >
            <td
              @click="gotToSubscription(item)"
              v-html
            >
              {{ _readableSubscriptionTitle(item) }}
            </td>
            <td>
              <v-chip
                small
                :color="chipColor(item)"
                outlined
              >
                <span>{{ chipText(item) }}</span>
              </v-chip>
            </td>
            <!--            <td>-->
            <!--              <v-chip-->
            <!--                small-->
            <!--                :color="item.collection_method === 'charge_automatically' ? 'info' : 'grey'"-->
            <!--                outlined-->
            <!--              >-->
            <!--                {{ item.collection_method === 'charge_automatically' ? 'Auto' : 'Manual' }}-->
            <!--              </v-chip>-->
            <!--            </td>-->
            <td v-date="item.created"/>
            <td>
              <v-menu
                v-if="item.status !== 'canceled'"
                left
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    v-on="on"
                  >
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>

                <v-list dense>
<!--                  <v-list-item @click="goToEditSubscription(item)">-->
<!--                    <v-list-item-content>-->
<!--                      <v-list-item-title>-->
<!--                        <v-icon-->
<!--                          left-->
<!--                          small-->
<!--                        >-->
<!--                          edit-->
<!--                        </v-icon>-->
<!--                        Edit-->
<!--                      </v-list-item-title>-->
<!--                    </v-list-item-content>-->
<!--                  </v-list-item>-->

                  <subscription-pause-dialog
                    v-if="_isEmpty(item.pause_collection)"
                    :id="item.id"
                    @action="reloadTable()"
                  >
                    <template v-slot:activator="{ on }">
                      <v-list-item
                        v-on="on"
                        @click.stop=""
                      >
                        <v-list-item-content>
                          <v-list-item-title>
                            <v-icon
                              left
                              small
                            >
                              pause
                            </v-icon>
                            Pause
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </subscription-pause-dialog>

                  <v-list-item
                    v-if="!_isEmpty(item.pause_collection)"
                    @click.stop="confirmResume = true"
                  >
                    <v-list-item-content>
                      <v-list-item-title>
                        <v-icon
                          left
                          small
                        >
                          play_arrow
                        </v-icon>
                        Resume
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <customer-cancel-subscription-dialog
                    :id="item.id"
                    :current-period-end="item.current_period_end || 0"
                    :customer="$route.params.id"
                    @action="reloadTable()"
                  >
                    <template v-slot:activator="{ on }">
                      <v-list-item
                        v-on="on"
                        @click.stop=""
                      >
                        <v-list-item-content>
                          <v-list-item-title class="red--text">
                            <v-icon left small class="red--text">
                              close
                            </v-icon>
                            Cancel
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </customer-cancel-subscription-dialog>
                </v-list>

                <confirm-action
                  :model="confirmResume"
                  :title="'Resume Subscription'"
                  :color="'primary'"
                  :description="`Are you sure you want to resume collecting payments? Any future invoices for this subscription will resume payment collection.`"
                  :action-text="'Resume'"
                  @cancel="confirmResume = false"
                  @confirmed="onConfirmResume(item.id)"
                />
              </v-menu>
            </td>
          </tr>
        </tbody>
      </template>
    </base-stripe-table>
  </v-container>
</template>
<script>
import { get, isEmpty } from 'lodash'
import BaseStripeTable from '@/components/Common/BaseStripeTable'
import CustomerCancelSubscriptionDialog from "./CustomerCancelSubscriptionDialog"
import { isErrorResponse, unixDateDiff } from "../../services/util.service"
import {
  readableSubscriptionTitle,
  readableSubscriptionSubitle
} from "../../services/stripe.service"
import SubscriptionPauseDialog from "../Subscription/SubscriptionPauseDialog"
import moment from 'moment'
import ConfirmAction from "../Common/ConfirmAction"
import { mapActions } from 'vuex'

export default {
  components: {
    ConfirmAction,
    SubscriptionPauseDialog,
    CustomerCancelSubscriptionDialog,
    BaseStripeTable
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      confirmResume: false,
      headers: [
        {
          text: 'Product',
          align: 'left',
          sortable: false,
        },
        {
          text: 'Status',
          sortable: false,
        },
        // {
        //   text: 'Billing',
        //   sortable: false,
        // },
        {
          text: 'Created',
          sortable: false
        },
        {
          text: '',
          sortable: false,
        }
      ]
    }
  },
  methods: {
    ...mapActions([ 'updateSubscription', 'snackError', 'snackSuccess' ]),
    _readableSubscriptionTitle: item => readableSubscriptionTitle(item),
    _isEmpty: val => isEmpty(val),
    onConfirmResume(id) {
      const payload = {
        id,
        pause_collection: null
      }
      this.updateSubscription(payload)
        .then(res => {
          if (!isErrorResponse(res)) {
            const successPayload = {
              text: 'Subscription resumed'
            }
            this.snackSuccess(successPayload)
            this.reloadTable()
          }

          this.confirmResume = false

          return res
        })
    },
    gotToSubscription(item) {
      this.$router.push({
        name: 'subscription-detail',
        params: { id: item.id }
      })
    },
    goToCreateSubscription() {
      this.$router.push({
        name: 'create-subscription',
        query: { customer: this.id }
      })
    },
    goToEditSubscription(item) {
      this.$router.push({
        name: 'subscription-edit',
        params: { id: item.id }
      })
    },
    chipText(item) {
      const { status, pause_collection } = item
      let text = status

      const map = {
        active: 'Active',
        trialing: 'Trialing',
        canceled: 'Cancelled',
        //paused: 'Paused', // there is no Paused status
      }

      if (status in map) {
        text = map[ status ]

        if (status === 'canceled') {
          // text is returned
        } else if (status === 'trialing') {
          const { trial_end, trial_start } = item
          const numDays = this.dateDiff(trial_start, trial_end)
          const plural = numDays > 1 ? 's' : ''

          text = `Trial ends in ${numDays} day${plural}`
        } else if (!isEmpty(pause_collection)) {
          // Paused subscriptions are still considered active
          const { behaviour, resumes_at } = pause_collection

          if (resumes_at) {
            const untilDate = moment.unix(resumes_at).format('LL')
            text = `Paused until ${untilDate}`
          } else {
            text = 'Paused'
          }
        }
      }

      return text
    },
    chipColor(item) {
      const { status, pause_collection } = item

      const map = {
        active: 'success',
        trialing: 'info',
        canceled: 'red'
      }

      if (status === 'canceled') {
        return map[status]
      } else if (!isEmpty(pause_collection)) {
        return 'warning'
      } else {
        return status in map
          ? map[ status ]
          : 'grey'
      }
    },
    isActive(item) {
      return item.status === 'active'
    },
    reloadTable() {
      this.$refs.subscriptionTable.fetchData()
    },
    dateDiff(start, end) {
      return unixDateDiff(start, end)
    }
  },
}
</script>
